import { useSelector } from 'react-redux'
import RootState from 'store/state'

export default function useAgents() {
    const agents = useSelector<RootState, RootState['agents']>(({ agents }) => agents)

    return agents
}
